
    import {
        defineComponent,
    } from 'vue';
    import { formatNumber } from '@ve/services/textModifiers';
    import useHotelMinPriceButton from '../common/useHotelMinPriceButton';

    export default defineComponent({
        name: 'HotelMinPriceButtonSeoDesktop',
        props: {
            hotelNameWithCategory: {
                type: String,
                required: true,
            },
            pageMinPrice: {
                type: Number,
                default: null,
            },
        },
        setup() {
            const {
                priceText,
            } = useHotelMinPriceButton();

            return {
                priceText,
                formatNumber,
            };
        },
    });
